function Viewport(breakpoints) {
    // Get the breakpoint config
    this.breakpoints = breakpoints;

    // Constuct the breakpoint for the media query
    this.mediaQuery = function (breakpoint) {
        return (
            '(' +
            this.breakpoints[breakpoint].type +
            ': ' +
            this.breakpoints[breakpoint].size +
            'px)'
        );
    };

    // Check if the media query matches
    this.matchMedia = function (breakpoint) {
        return window.matchMedia(this.mediaQuery(breakpoint));
    };

    // Check if the media query matches
    this.matches = function (breakpoint) {
        return window.matchMedia(this.mediaQuery(breakpoint)).matches;
    };

    // Construct the custom media query
    this.customMediaQuery = function (breakpoint) {
        return breakpoint;
    };

    // Check if the custom media query matches
    this.customMatchMedia = function (breakpoint) {
        return window.matchMedia(this.customMediaQuery(breakpoint));
    };

    // Check if the custom media query matches
    this.customMatches = function (breakpoint) {
        return window.matchMedia(this.customMediaQuery(breakpoint)).matches;
    };

    // Watch for viewport resize
    this.resize = function (callback) {
        var windowResizing;

        window.addEventListener('resize', function () {
            clearTimeout(windowResizing);
            windowResizing = setTimeout(function () {
                if (typeof callback == 'function') {
                    callback();
                }
            }, 100);
        });
    };
}


function ProductStickyCta() {
    var self = this;

    var viewport = new Viewport(Soho.breakpoints);
    var localStorage = new LocalStorageManager();

    this.delay = 300;
    this.duration = 1000;
    this.footerDockOffset = 20;
    this.canCheckPageScroll = true;
    this.active = {
        trigger: false,
        success: false
    }

    this.refresh = function() {
        var previousTrigger = this.trigger;

        this.$form = document.querySelectorAll('.js-basket-form');
        this.$btn = document.querySelector('[data-product-sticky-cta-trigger]')
            || document.querySelector('.js-basket-form button.product-detail__add');
        this.trigger = document.querySelector('.js-product-sticky-cta-trigger');
        this.$countContainer = document.querySelector('.js-basket-count');
        this.$count = document.querySelector('.js-basket-count .header-action__count');

        if (previousTrigger && previousTrigger !== this.trigger) {
            this.active.trigger = false;
        }
    }

    this.init = function() {
        this.refresh();

        if (this.$form.length === 0) {
            return;
        }

        if (localStorage.get('waitlist-added') === 'true') {
            document.querySelectorAll('.js-more-info-toggle[data-more-info-disable="true"]').forEach(function(el) {
                self.disableItem(el);
            });
        }

        this.watchScroll();
        this.watchResize();
    }

    this.watchScroll = function() {
        this.checkPageScroll();

        document.addEventListener('scroll', this.checkPageScroll.bind(this));
    }

    this.watchResize = function() {
        viewport.matchMedia('tablet').addListener(this.checkPageScroll.bind(this));
    }

    this.checkPageScroll = function() {        
        if (!this.canCheckPageScroll) {
            return;
        }

        this.refresh();

        if (this.$form.length === 0 || !this.$btn || !this.trigger) {
            return;
        }

        var valid = true;

        if (!viewport.matches('tablet') && localStorage.get('waitlist-added') && this.$form[0].getAttribute('action') === null) {
            valid = false;
        }
        
        if (valid) {
            this.additionalElements = [
                document.querySelector('.notice'),
                document.querySelector('.header'),
            ];

            let top = 0;

            this.additionalElements.forEach(function(el) {
                if (el) {
                    top += el.offsetHeight;
                }
            });

            if (top > this.$btn.getBoundingClientRect().top + this.$btn.getBoundingClientRect().height) {
                this.activate(this.trigger, 'trigger');
            } else {
                this.deactivate(this.trigger, 'trigger');
            }
        } else {
            this.deactivate(this.trigger, 'trigger');
        }

        const footerWrap = document.querySelector('.footer__wrap');

        if (viewport.matches('tablet')) {
            if (window.pageYOffset > this.trigger.querySelector('.product-sticky-cta__container').clientHeight / 2) {
                this.trigger.classList.add('product-sticky-cta--show');
            } else {
                this.trigger.classList.remove('product-sticky-cta--show');
            }

            const height = this.trigger.querySelector('.product-sticky-cta__container').clientHeight;

            if (footerWrap) {
                footerWrap.style.paddingBottom = `${height}px`;
            }
        } else {
            this.dockAboveFooter();

            if (footerWrap) {
                footerWrap.style.paddingBottom = null;
            }
        }
    }

    /**
     * Keep the sticky CTA above the footer by raising its fixed bottom
     * once the bar would otherwise overlap the footer top.
     */
    this.dockAboveFooter = function() {
        var container = this.trigger && this.trigger.querySelector('.product-sticky-cta__container');
        var footer = document.querySelector('.footer');

        if (!container || !footer || !this.active.trigger) {
            if (container) {
                container.style.bottom = '';
            }
            return;
        }

        var bottomOffset = viewport.matches('tablet') ? 0 : 10;
        var dockedBottom = window.innerHeight - footer.getBoundingClientRect().top - this.footerDockOffset;

        if (dockedBottom > bottomOffset) {
            container.style.bottom = dockedBottom + 'px';
        } else {
            container.style.bottom = '';
        }
    }

    this.update = function(count) {
        this.refresh();

        if (!this.$countContainer || !this.$count) {
            return;
        }

        if (parseInt(count) > 0) {
            this.$countContainer.classList.add('header-action--active');
        } else {
            this.$countContainer.classList.remove('header-action--active');
        }
        this.$count.innerHTML = count;
    }

    this.disableCheckPageScroll = function() {
        this.canCheckPageScroll = false;
    }

    this.enableCheckPageScroll = function() {
        this.canCheckPageScroll = true;
    }

    this.activate = function(el, mode) {
        if (this.active[mode]) {
            return
        }

        this.active[mode] = true;

        el.classList.add('product-sticky-cta--active-a');

        if (Soho.ContentSquare && !window.stickyAtbSentToCs) {
            Soho.ContentSquare.trackArtificialPageview(window.location.pathname + '/sticky-add-to-basket')
            window.stickyAtbSentToCs = true
        }

        setTimeout(function() {
            el.classList.add('product-sticky-cta--active-b');
            setTimeout(function() {
                el.classList.add('product-sticky-cta--active-c');
            }, self.delay);
        }, 1);
    }

    this.deactivate = function(el, mode) {
        if (!this.active[mode]) {
            return
        }

        var container = el.querySelector('.product-sticky-cta__container');
        if (container) {
            container.style.bottom = '';
        }

        el.classList.remove('product-sticky-cta--active-c');

        setTimeout(function() {
            el.classList.remove('product-sticky-cta--active-b');
            setTimeout(function() {
                el.classList.remove('product-sticky-cta--active-a');
                self.active[mode] = false;
            }, self.delay);
        }, 1);
    }

    this.disable = function(el, mode, toggle, tablet) {
        toggle.forEach(function(el) {
            if (el.closest('.banners') !== null) {
                self.disableItem(el);
            }
        });
        if (!tablet) {
            this.deactivate(el, mode);
        }
    }

    this.disableItem = function(el) {
        el.style.transition = 'none';
        el.disabled = true;
        el.querySelector('span').innerHTML = 'You have joined the waitlist';
    }
}


var productStickyCta = new ProductStickyCta();
productStickyCta.init();
